import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const allowedTracingDomains = ['.lemonade.com', '.lmndstaging.com'];
const allowedStages = ['production', 'staging'];

export const initializeDatadogRum = () => {
  const stage = process.env.NEXT_PUBLIC_STAGE ?? 'development';

  if (!allowedStages.includes(stage)) return;

  try {
    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? '',
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '',
      site: 'datadoghq.com',
      service: 'marketing-edge',
      env: stage,
      version: '1.0.0',
      sessionSampleRate: Number(process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE ?? 0),
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: 'mask-user-input',
      trackingConsent: 'not-granted',
      plugins: [reactPlugin({ router: false })],
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      allowedTracingUrls: [
        url => {
          try {
            const parsedURL = new URL(url);
            return allowedTracingDomains.some(domain => parsedURL.hostname.endsWith(domain));
          } catch (e: unknown) {
            console.log(e);
            return false;
          }
        },
      ],
    });
  } catch (error) {
    console.error('Error initializing Datadog RUM', error);
  }
};

export const trackWithDatadogRum = (event: string, params: Record<string, unknown>) => {
  try {
    datadogRum.addAction(event, params);
  } catch (e: unknown) {
    console.log(e);
    // Silent fail or log locally
    console.warn('Error tracking event with Datadog RUM');
  }
};
